(() => {
  function init(root) {
    if (root.dataset.videoReady === 'true') return;
    const video = root.querySelector('video');
    const button = root.querySelector('[data-og-video-toggle]');
    if (!video || !button) return;
    root.dataset.videoReady = 'true';
    const motion = matchMedia('(prefers-reduced-motion: reduce)');
    let pendingPlay = false;
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    video.loop = true;
    button.hidden = false;
    const sync = () => {
      button.textContent = video.paused ? button.dataset.playLabel : button.dataset.pauseLabel;
    };
    const play = () => {
      if (video.readyState < 1) { pendingPlay = true; return; }
      pendingPlay = false;
      const result = video.play();
      if (result && typeof result.catch === 'function') result.catch(() => {
        video.controls = true;
        sync();
      });
    };
    button.addEventListener('click', () => {
      if (video.paused && !pendingPlay) play();
      else { pendingPlay = false; video.pause(); }
    });
    video.addEventListener('loadedmetadata', () => { if (pendingPlay) play(); });
    video.addEventListener('play', sync);
    video.addEventListener('pause', () => { pendingPlay = false; sync(); });
    video.addEventListener('error', () => { pendingPlay = false; video.controls = true; sync(); });
    motion.addEventListener('change', () => {
      if (motion.matches) {
        pendingPlay = false;
        video.autoplay = false;
        video.pause();
      }
    });
    if (!motion.matches) play();
    sync();
  }
  document.querySelectorAll('[data-og-hero-video]').forEach(init);
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll('[data-og-hero-video]').forEach(init);
  });
})();
